import { component } from "preact";
import { css } from "emotion";

const P = ({
  color = "#323232",
  marginTop = 0,
  marginBottom = 0,
  breakpoint = 768,
  marginBottomMobile = 0,
  marginTopMobile = 0,
  maxWidth = "none",
  mobileMaxWidth = "none",
  semiBold = false,
  children
}) => {
  const styleObj = {
    fontSize: 16,
    fontWeight: semiBold ? 600 : 400,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom,
    maxWidth: maxWidth,
    marginLeft: maxWidth === "auto" ? 0 : "auto",
    marginRight: maxWidth === "auto" ? 0 : "auto"
  };

  styleObj[`@media(max-width:${breakpoint}px)`] = {
    fontSize: 14,
    marginTop: marginTopMobile,
    marginBottom: marginBottomMobile
  };
  const style = css(styleObj);

  return <p className={style}>{children}</p>;
};

export default P;
